import { P } from 'ia-react-core';
import styled from 'styled-components';

export const StyledP = styled(P)`
  display: block;
`;

export const StyledCheckboxItem = styled.span`
  padding-right: 8px;
`;

export const StyledCheckboxItemContract = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.gray14};
`;

export const StyledCheckboxListControlWrapper = styled.div`
  label {
    padding-bottom: 8px !important;
  }
  span {
    > span {
       span {
      border: 2px solid ${({ theme }) => theme.colors.gray13};
    }
    }
  }

`;
